import React, { useState, useEffect } from 'react';
import { Form, Row, Col, Button, InputGroup } from 'react-bootstrap';
import { getAliCategories } from './aliapi';

const AliSearchBar = ({ onSearch }) => {
  const [keyword, setKeyword] = useState('');
  const [category, setCategory] = useState('');
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    getAliCategories()
      .then((data) => setCategories(data.categories || []))
      .catch((error) => console.error('Failed to fetch AliExpress categories', error));
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    onSearch({ keyword, category });
  };

  return (
    <Form
      onSubmit={handleSubmit}
      className="p-3 rounded-4 shadow-sm mb-4"
      style={{
        background: 'rgba(13,110,253,.06)',
        border: '1px solid rgba(13,110,253,.15)',
        backdropFilter: 'blur(4px)',
        WebkitBackdropFilter: 'blur(4px)'
      }}
    >
      <Row className="g-2 align-items-center">
        <Col xs={12} md={6}>
          <InputGroup>
            <Form.Control
              type="text"
              placeholder="Search auto parts..."
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              aria-label="Search keyword"
              style={{ background: 'rgba(255,255,255,.9)' }}
            />
            <Button type="submit" variant="primary" className="fw-semibold">
              Search
            </Button>
          </InputGroup>
        </Col>
        <Col xs={12} md={4}>
          <Form.Select
            value={category}
            onChange={(e) => setCategory(e.target.value)}
            aria-label="Select category"
            style={{ background: 'rgba(255,255,255,.95)' }}
          >
            <option value="">All Categories</option>
            {categories.map((cat) => (
              <option key={cat.category_id} value={cat.category_id}>
                {cat.category_name}
              </option>
            ))}
          </Form.Select>
        </Col>
        <Col xs={12} md={2}>
          <Button
            type="submit"
            variant="primary"
            className="w-100 fw-semibold"
            style={{ transition: 'transform .15s ease' }}
            onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.02)')}
            onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
          >
            Apply
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

export default AliSearchBar;
